import { useRef, useState, useMemo } from "react"
import { FaPause, FaPlay } from "react-icons/fa"
import { FiHeadphones } from "react-icons/fi"
import styles from "../../index.module.less"
import { Text } from "components/common"
import { t } from "i18next"

export const WhatsappAudioMessage = ({ audioUrl, duration = 0 }) => {
  const audioRef = useRef(null)
  const [playing, setPlaying] = useState(false)
  const [progress, setProgress] = useState(0)
  const [currentTime, setCurrentTime] = useState(0)

  const formattedDuration = useMemo(() => {
    const dur = typeof duration === 'string' ? parseFloat(duration) : duration
    if (!dur || dur <= 0) return "0:00"
    const m = Math.floor(dur / 60)
    const s = Math.floor(dur % 60)
    return `${m}:${s.toString().padStart(2, '0')}`
  }, [duration])

  const formattedCurrentTime = useMemo(() => {
    if (!currentTime) return ""
    const m = Math.floor(currentTime / 60)
    const s = Math.floor(currentTime % 60)
    return `${m}:${s.toString().padStart(2, '0')}`
  }, [currentTime])

  const handlePlayPause = () => {
    if (!audioRef.current) return
    if (playing) {
      audioRef.current.pause()
    } else {
      audioRef.current.play()
    }
  }

  const handleProgressClick = (e) => {
    if (!audioRef.current?.duration) return
    const rect = e.currentTarget.getBoundingClientRect()
    const clickX = e.clientX - rect.left
    const newTime = (clickX / rect.width) * audioRef.current.duration
    audioRef.current.currentTime = newTime
  }

  const handleTimeUpdate = () => {
    if (audioRef.current) {
      const { currentTime, duration } = audioRef.current
      setProgress(duration ? currentTime / duration : 0)
      setCurrentTime(currentTime)
    }
  }

    if (!audioUrl) return <Text className={styles.audioMsg} type="secondary">{t("Audio unavailable")}</Text>

  return (
    <>
      <div className={styles.audioMsg}>
        <div className={styles.audioIconBox}>
          <FiHeadphones className={styles.audioIcon} />
          <span className={styles.audioDurationBox}>
            {formattedCurrentTime || formattedDuration}
          </span>
        </div>
        
        <button
          className={styles.audioPlayBtn}
          onClick={handlePlayPause}
          style={{ background: "none", border: "none", cursor: "pointer" }}
        >
          {playing ? <FaPause /> : <FaPlay />}
        </button>

        <div 
          className={styles.audioProgressBar}
          onClick={handleProgressClick}
          style={{ cursor: 'pointer' }}
        >
          <div 
            className={styles.audioProgress} 
            style={{ width: `${progress * 100}%` }} 
          />
        </div>
      </div>
      
      <audio
        ref={audioRef}
        src={audioUrl}
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
        onEnded={() => {
          setPlaying(false)
          setProgress(0)
          setCurrentTime(0)
        }}
        onTimeUpdate={handleTimeUpdate}
        style={{ display: "none" }}
      />
    </>
  )
}
